// ConfirmDialog.tsx — small reusable Yes/Cancel confirmation modal.
// Used wherever a destructive-but-recoverable action (decline a follow
// request, etc.) needs a confirm step before firing. Mirrors
// features/settings/sections/ConfirmDropFollowersDialog.tsx's shape,
// generalized so a second near-identical dialog wasn't needed for decline.
import styled from 'styled-components';
import { Dialog, Button } from '@/ui';

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Message = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.sm};
  color: ${({ theme }) => theme.color.textMuted};
`;

const Row = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmDialog({ title, message, confirmLabel, onConfirm, onClose }: ConfirmDialogProps) {
  return (
    <Dialog open title={title} onClose={onClose}>
      <Stack>
        <Message>{message}</Message>
        <Row>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Row>
      </Stack>
    </Dialog>
  );
}
